// Menüler (paket / set ürün) listesi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
// Menü içeriğini düzenleyen pencerenin rehberi ayrıdır: inventory.productMenus
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.productMenusPage';

export const inventoryProductMenusPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Menüler sayfası nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Menü, birden fazla ürünü tek bir paket olarak satmanızı sağlar (ör. İkili Lahmacun Menü = 2 Lahmacun + 1 Ayran + 1 Salata). Bu sayfa tanımlı tüm menüleri bir arada gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve durum'),
    toolbar: t(`${G}.regions.toolbar`, 'Stok Listesi / Excel / Yenile'),
    table: t(`${G}.regions.table`, 'Menü listesi'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Menü nasıl oluşturulur?'),
      text: t(`${G}.s1.text`, 'Menü, stokta satılan bir ürüne bağlanır. Önce stok listesinde menü olarak satılacak ürünü açın (yoksa yeni ürün kartı oluşturun), satırın ⋮ menüsünden "Menü Tanımları"nı seçip menüyü oluşturun. "Stok Listesi" düğmesi sizi stok listesine götürür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Bir ürüne yalnız bir menü tanımlanabilir.'),
        t(`${G}.s1.tip2`, 'Menü içine başka menü eklenemez; menüdeki ürünlerin reçetesi olabilir, satışta o malzemeler de stoktan düşer.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Kartlar Toplam Menü, Aktif Menü, Pasif Menü sayısını ve tüm menülerdeki toplam ürün satırı sayısını gösterir.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Menüyü bulun'),
      text: t(`${G}.s3.text`, 'Arama kutusuna menü adı, menü kodu, ürün adı veya stok kodu yazın; "Durum" ile Aktif ya da Pasif menüleri ayırın. Etkin filtreler listenin üstünde görünür; "Filtreyi Temizle" hepsini kaldırır.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Sütunları okuyun'),
      text: t(`${G}.s4.text`, 'Her satırda menü adı ve kodu, menünün bağlı olduğu ürün, menüdeki ürün sayısı, seçim grubu sayısı, eksi stok ayarı, durum ve oluşturma tarihi yer alır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Seçim Grubu: müşterinin satışta alternatiflerden yalnız birini seçtiği gruplar (ör. İçecek: Cola / Ayran).'),
        t(`${G}.s4.tip2`, 'Eksi Stok: İzinli ise menüdeki ürünler eksiye düşebilir; Kapalı ise satışta stok kontrol edilir. Bu ayar menünün bağlı olduğu ürün kartındaki eksi stok ayarından alınır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Menüyü açıp içeriği ve fiyatı düzenleyin'),
      text: t(`${G}.s5.text`, 'Satıra ya da kalem simgesine ("Menüyü Aç") tıklayınca menü penceresi açılır. Orada ürün ekler, seçim grubu (opsiyonlu ürün) tanımlar ve ürünlere ekstra opsiyon verirsiniz. Ayrıntılar için pencerenin kendi (i) rehberine bakın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Menünün ayrı bir fiyat alanı yoktur; satışta menünün bağlı olduğu ürün satılır, fiyatını o ürün kartından değiştirirsiniz.'),
        t(`${G}.s5.tip2`, 'Ekstra opsiyon (ör. Küçük Cola → Büyük Cola +20₺) seçilirse fiyat farkı satış tutarına eklenir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Dışa aktarın, sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, '"Excel İndir" ekranda görünen sayfadaki menüleri Excel dosyasına aktarır; tümünü almak için sayfa başına satır sayısını artırın. Yenile düğmesi listeyi ve kartları tazeler. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
